import React, { useEffect, useState } from 'react'
import { OrderTransactionsGroupForm } from 'components/Order/OrderForms/OrderForm/OrderTransactionsForm/OrderTransactionsGroupForm/OrderTransactionsGroupForm'
import styles from 'components/Order/OrderForms/OrderForm/OrderTransactionsForm/OrderTransactionsForm.module.css'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { TransactionType } from './OrderTransactionsGroupForm/OrderTransactionForm/TransactionType'
import { FormRow } from 'components/Shared/CrudComponents'
import { ORDER_COST_READ, ORDER_COST_WRITE, ORDER_INCOME_READ, ORDER_INCOME_WRITE, useAuth } from 'context/auth'
import { fetchTransactionServices } from 'services'
import { useErrorHandling } from 'context/errorHandling'

export function OrderTransactionsForm ({
  name,
  onCostRemoved,
  isTransactionDisabled
}) {
  const [transactionServiceTypes, setTransactionServiceTypes] = useState(null)

  const { handleError } = useErrorHandling()

  useEffect(() => {
    fetchTransactionServices()
      .then(setTransactionServiceTypes)
      .catch(handleError)
  }, [handleError])


  const { t } = useTranslation()
  const { values } = useFormikContext()
  const { hasAnyPrivileges } = useAuth()

  const transactions = values[name]
  const defaultPayerId = values?.contractorInfo?.payerId
  const defaultCarrierId = values?.carrier?.id

  const hasOrderIncomeReadPrivilege = hasAnyPrivileges([ORDER_INCOME_READ])
  const hasOrderCostReadPrivilege = hasAnyPrivileges([ORDER_COST_READ])
  return ((hasOrderIncomeReadPrivilege || hasOrderCostReadPrivilege) &&
    <div>
      <div className={styles.header}>
        <h2>{t('form.order.transaction.title')}</h2>
      </div>
      <FormRow>
        {hasOrderIncomeReadPrivilege &&
          <OrderTransactionsGroupForm name={`${name}.incomes`}
                                      defaultContractor={defaultPayerId}
                                      type={TransactionType.Income}
                                      transactions={transactions.incomes}
                                      onContractorCreated={() => false}
                                      transactionServiceTypes={transactionServiceTypes?.filter(transaction => transaction.type === 'INCOME')}
                                      disabled={!hasAnyPrivileges([ORDER_INCOME_WRITE])}
                                      isTransactionDisabled={() => false}/>
        }
        {hasOrderCostReadPrivilege &&
          <OrderTransactionsGroupForm name={`${name}.costs`}
                                      defaultContractor={defaultCarrierId}
                                      type={TransactionType.Cost}
                                      transactions={transactions.costs}
                                      onContractorCreated={() => false}
                                      transactionServiceTypes={transactionServiceTypes?.filter(transaction => transaction.type === 'COST')}
                                      onCostRemoved={onCostRemoved}
                                      disabled={!hasAnyPrivileges([ORDER_COST_WRITE])}
                                      isTransactionDisabled={isTransactionDisabled}/>
        }
      </FormRow>
    </div>
  )
}
